<template>
  <v-card>
    <v-card-text>
      <v-container class="pa-0">
        <v-row v-if="filteredEmployees.length > 5">
          <v-col :cols="12" :md="3" :offset-md="9">
            <v-text-field
              append-icon="search"
              :label="$t('texts.search')"
              single-line
              hide-details
              v-model="search"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="12">
            <v-data-table
              :headers="headers"
              :items="filteredEmployees"
              :search="search"
              must-sort
              item-key="resume_entry_id"
              :no-data-text="$t('texts.employee.noEntries')"
              :no-results-text="$t('texts.noSearchEntries')"
              :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
              class="elevation-0"
              :loading="fetchEmployeesPending"
              :hide-default-footer="filteredEmployees.length < 5"
            >
              <template v-slot:item.cooperationAgreements="{ item }">
                <v-btn
                  v-if="item.cooperation_agreements.length >= 1"
                  icon class="mx-0"
                  @click="showPdfDialog({
                    title: $tc('texts.cooperationAgreement', 1),
                    pdfLink: item.cooperation_agreements[0].url
                  })"
                >
                  <v-icon color="primary">insert_drive_file</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.cooperation_agreements.length === 2"
                  icon class="mx-0"
                  @click="showPdfDialog({
                    title: $tc('texts.cooperationAgreement', 1),
                    pdfLink: item.cooperation_agreements[1].url
                  })"
                >
                  <v-icon color="primary">insert_drive_file</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.reenter="{ item }">
                <v-btn
                  v-if="item.renewal_checked_on === null && item.type !== 'future'"
                  @click="openEditEmployeeReEnterDialog(item)"
                  small
                  color="primary"
                >
                  {{ $t('texts.employeeReEnter.label') }}
                </v-btn>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip
                  v-if="item.type !== 'past'"
                  color="info" top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click="openEditEmployeeDialog(item)"
                    >
                      <v-icon color="primary">mode_edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('texts.edit') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');
const { mapState: mapCompanyEmployeesState, mapActions: mapCompanyEmployeesActions } = createNamespacedHelpers('company/employees');

export default {
  name: 'CompanyEmployeesDatatable',
  data() {
    return {
      search: '',
    };
  },
  created() {
    this.fetchEmployees({
      companyId: this.selectedCompanyId,
      listType: this.listType,
    });
  },
  computed: {
    ...mapCompanyEmployeesState([
      'fetchEmployeesPending',
      'employees',
    ]),
    ...mapCompanyProfileState([
      'company',
    ]),
    listType() {
      return this.$route.meta.listType;
    },
    headers() {
      const headers = [
        {
          text: `${this.$i18n.t('texts.firstName')} ${this.$i18n.t('texts.lastName')}`,
          value: 'formattedName',
          align: 'left',
        },
        { text: this.$i18n.t('texts.insertJobtitle'), value: 'title', align: 'left' },
        { text: this.$i18n.t('texts.startOfWork'), value: 'formattedStartDate', align: 'left' },
        { text: this.$i18n.t('texts.endOfWork'), value: 'formattedEndDate', align: 'left' },
        {
          text: this.$i18n.tc('texts.cooperation', 2), value: 'cooperationAgreements', align: 'center', sortable: false,
        },
        {
          text: this.$i18n.t('texts.employeeReEnter.label'), value: 'reenter', align: 'center', sortable: false,
        },
        {
          text: '', value: 'actions', align: 'right', sortable: false,
        },
      ];
      return headers;
    },
    filteredEmployees() {
      if (this.employees.length > 0) {
        return this.employees
          .map((item) => {
            const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
            const formattedStartDate = this.$options.filters.formatDateShort(item.start_date);
            const formattedEndDate = this.$options.filters.formatDateShort(item.end_date);
            const formattedItem = {
              ...item,
              formattedName,
              formattedStartDate,
              formattedEndDate,
            };
            return formattedItem;
          });
      }
      return [];
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyEmployeesActions([
      'fetchEmployees',
    ]),
    showPdfDialog(item) {
      this.$eventBus.$emit('show-pdf-dialog', item);
    },
    openEditEmployeeReEnterDialog(item) {
      this.$eventBus.$emit('show-edit-employee-reenter-dialog', item);
    },
    openEditEmployeeDialog(item) {
      this.$eventBus.$emit('show-edit-employee-dialog', item);
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
